import { CountryIconProps } from './types';

const AF = ({ dimension }: CountryIconProps) => (
  <svg
    width={dimension || 24}
    height={dimension || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1046_3551)">
      <path
        d="M17.2175 1.19072C15.6399 0.427875 13.87 0 12.0001 0C10.1303 0 8.36037 0.427875 6.78274 1.19072L5.73926 12L6.78274 22.8093C8.36037 23.5721 10.1303 24 12.0001 24C13.87 24 15.6399 23.5721 17.2175 22.8093L18.261 12L17.2175 1.19072Z"
        fill="#D80027"
      />
      <path
        d="M6.78262 1.19135C2.76872 3.1323 0 7.24272 0 12.0002C0 16.7577 2.76872 20.8681 6.78262 22.8091V1.19135Z"
        fill="black"
      />
      <path
        d="M17.2178 1.19135V22.8091C21.2317 20.8681 24.0004 16.7577 24.0004 12.0002C24.0004 7.24272 21.2317 3.1323 17.2178 1.19135Z"
        fill="#496E2D"
      />
      <path
        d="M12.0001 7.82672C9.69484 7.82672 7.82617 9.69544 7.82617 12.0006C7.82617 14.3058 9.69489 16.1745 12.0001 16.1745C14.3052 16.1745 16.174 14.3058 16.174 12.0006C16.174 9.69544 14.3053 7.82672 12.0001 7.82672ZM12.0001 14.6093C10.5593 14.6093 9.39138 13.4413 9.39138 12.0006C9.39138 10.5599 10.5594 9.39192 12.0001 9.39192C13.4408 9.39192 14.6088 10.5599 14.6088 12.0006C14.6088 13.4413 13.4408 14.6093 12.0001 14.6093Z"
        fill="#FFDA44"
      />
      <path
        d="M12.0005 10.4362C11.4242 10.4362 10.957 10.9034 10.957 11.4797V13.0449H13.044V11.4797C13.044 10.9034 12.5768 10.4362 12.0005 10.4362Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_1046_3551">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default AF;
